/**
 * WordPress dependencies.
 */
import { render, Fragment, useState } from "@wordpress/element";

/**
 * Internal dependencies.
 */
import "./style.scss";
import { AdminNotices, SnakeNotices } from "./Notices.js";
import Main from "./Main.js";
import useSettings from "./helpers-settings.js";

if (undefined === window.ahscUtils) {
	window.ahscUtils = {};
}
window.ahscUtils.const = ahscisleGutenberg;
window.ahscUtils.useSettings = useSettings;

const App = () => {
	const [currentTab, setTab] = useState("general");
	return (
		<Fragment>
			{undefined !== wp.notices.store && <AdminNotices />}
			{undefined !== wp.notices.store && <SnakeNotices />}
			<Main currentTab={currentTab} setTab={setTab} settings={useSettings} />
		</Fragment>
	);
};

render(<App />, document.getElementById("ahsc-settings"));
